import { GalleryJson } from "./Gallery"
import { AiEffectSequenceResource } from "./models/AiEffectSequenceResource"

export interface BackgroundColorFill {
  type: ColorFillType
  style: GradientStyle
}

export interface BackgroundColorFillSolid extends BackgroundColorFill {
  color: string
}

export interface BackgroundColorFillGradient extends BackgroundColorFill {
  firstColor: string
  secondColor: string
}

export enum ColorFillType {
  SOLID = "SOLID",
  GRADIENT = "GRADIENT",
}

export enum GradientStyle {
  RADIAL = "RADIAL",
  LINEAR = "LINEAR",
}

export interface PresetImage {
  url: string
  height: number
}

export interface PresetBackgroundImage extends PresetImage {
  opacity: number
  fit: string
}

export interface PresetJson {
  id: number
  code: string
  textColor: string
  heading: string
  subheading: string
  uploadingEnabled: boolean
  hasAvailableCredits: boolean
  hideAttribution: boolean
  backgroundReplacementRequired: boolean
  emailCaptureEnabled: boolean
  _embedded: {
    backgroundColorFill: BackgroundColorFill
    backgroundImage: PresetBackgroundImage
    headerImage: PresetImage | undefined
    overlays: PresetImage[]
    stickers: PresetImage[]
    backgroundReplacements: PresetImage[]
    gallery: GalleryJson
    ageGate: {
      enabled: boolean
      prompt: string
      minimumAge: number
    }
    participantData: {
      emailAddressCaptureEnabled: boolean
      firstNameCaptureEnabled: boolean
      lastNameCaptureEnabled: boolean
      phoneNumberCaptureEnabled: boolean
    }
    aiEffectSequence: AiEffectSequenceResource | null
  }
}
